import { render, staticRenderFns } from "./LxAutocomplete.vue?vue&type=template&id=b4528e3e&scoped=true&"
import script from "./LxAutocomplete.vue?vue&type=script&lang=js&"
export * from "./LxAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./LxAutocomplete.vue?vue&type=style&index=0&id=b4528e3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4528e3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardActions,VDivider,VMenu,VTextField})
